import React from 'react';
import { RelativeDatePeriod, RelativeDateType, RelativeUnit } from '@fabric-ui/components';
import { Automations, History } from '@fabric-ui/icons';

export const TimeframeOptions = {
  current: { value: 'Current', icon: <Automations /> },
  historic: { value: 'Historical', icon: <History /> },
};

export const dateFormat = 'MMM dd, yy';

export const newDefaultTimeRange = {
  value: {
    relative: {
      unit: RelativeUnit.DAYS,
      value: 30,
      periodBehaviour: RelativeDateType.last,
    },
  },
  preset: {
    count: 30,
    period: RelativeDatePeriod.days,
    type: RelativeDateType.last,
  },
};
